export default __webpack_public_path__ + "media/images/svg/dog-decor-3a-5e365ed8af97a7793ed7abcb81144bd6.svg";